import { freeUserUpgradeStep } from '../utils';

export const rescuesListTour = {
  tourKey: 'rescues_list',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: null,
  },
  steps: [
    {
      // Welcome step - centered
      title: 'tours.my-rescues-npo.welcome.title',
      content: 'tours.rescues-list.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="rescues-table"]',
      title: 'tours.rescues-list.table.title',
      content: 'tours.rescues-list.table.content',
      placement: 'top',
    },
    freeUserUpgradeStep,
  ],
};
